import styled, { css } from 'styled-components';

import { fadeAnimation } from '~/theme/GlobalStyles';
import { ThemeProp } from '~/theme/Themes';

interface SubHeaderContainerProps {
  $animated?: boolean;
}

export const SubHeaderContainer = styled.div<SubHeaderContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 299;
  animation: ${(props: SubHeaderContainerProps) =>
    props.$animated
      ? css`
          ${fadeAnimation} 0.3s ease-in-out
        `
      : 'none'};
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    position: sticky;
    top: 0;
    background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
    border-bottom: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
    z-index: 302;
  }
`;

export const DesktopContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 1.5rem;
  padding-bottom: 0;
  gap: 1rem;
  align-items: center;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  display: none;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    gap: 0.5rem;
    width: 100%;
    overflow-x: auto;
  }
`;

export const FiltersSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    gap: 0.5rem;
    flex: 1;
  }
`;

export const SearchSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  justify-content: flex-end;
  margin-left: auto; /* Always push to the right */

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    gap: 0.5rem;
    margin-left: 0; /* Reset on mobile */
  }
`;

export const ActionsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    gap: 0.5rem;
  }
`;

export const FiltersLabel = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.m};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.m};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;
